<template>
  <div v-if="terpenes.length > 0" :class="profile ? 'product-profile-block terpene-profile-wrap accordion is-active' : 'product-profile-block accordion'">
    <div class="accordion-header toggle pr-0" @click="profile = !profile">
      <p class="has-text-weight-bold">Terpene Profile</p>
      <button class="toggle" aria-label="toggle">
        <i :class="profile ? 'text-white fas fa-sort-up' : 'text-white fas fa-sort-down'"></i>
      </button>
    </div>
    <div class="accordion-body">
      <div class="accordion-content pr-0">
        <div class="is-flex-mobile is-flex-wrap" v-if="terpenes.length > 0" >
          <div class="terpene-tag" v-bind:key="'terpene_' + terpene.id" v-for="terpene in terpenes">
          {{terpene.name}}
          </div>
          <div class="column is-12 py-0" v-if="terpenes.length < 1 ">
            <p class="text-sm">No data.</p>
          </div>
        </div>
        <div v-else>
          <p class="text-white consumption-note text-13">Not Available.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetailProfile',
  data() {
    return {
      profile: false,
    };
  },
  props: ['terpenes'],
  methods: {
  },
};
</script>

<style scoped>
.item-image img {
  max-width: 63px;
}
.item-image {
  min-height: 73px;
  justify-content: center;
  align-items: center;
  display: flex;
}
.column.is-6.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.text-sm{
  font-size:13px;
}
</style>